export default __webpack_public_path__ + "static/media/mailBlack.31463b69.svg";